import labelIds from './label_ids.json';

type LabelKey = keyof typeof labelIds;

type StringKeys = Exclude<LabelKey, 'context'>;

export const defaultMessages: Record<StringKeys, string> = {
  'media-ui-core_search': 'Search',
  'media-ui-core_linkCopied': 'Link Copied',
  'media-ui-core_beforeItsHereItsOnTheBloombergTerminal':
    "Before it's here, it's on the Bloomberg Terminal.",
  'media-ui-core_learnMore': 'Learn More',
  'media-ui-core_haveAConfidentialTipForOurReporters':
    'Have a confidential tip for our reporters?',
  'media-ui-core_getInTouch': 'GET IN TOUCH',
  'media-ui-core_newslettersWillBeSentToEmail':
    'Newsletters will be sent to {email}',
  'media-ui-core_signUpToThisNewsletter': 'Sign up to this newsletter',
  'media-ui-core_signUp': 'Sign Up',
  'media-ui-core_youreSignedUp': "You're signed up!",
  'media-ui-core_loading': 'Loading...',
  'media-ui-core_nextButtonText': 'Next',
  'media-ui-core_previousButtonText': 'Previous',
  'media-ui-core_shareThisArticle': 'Share this article',
  'media-ui-core_lessThan1mAgo': '<1m ago',
  'media-ui-core_lessThanAMinuteAgo': 'Less than a minute ago',
  'media-ui-core_approxDaysAgoShort': '{days}d ago',
  'media-ui-core_approxDaysAgoLong': '{days} days ago',
  'media-ui-core_approxMonthsAgoShort': '{months}mo ago',
  'media-ui-core_approxMonthsAgoLong': '{months} months ago',
  'media-ui-core_approxYearsAgoShort': '{years}y ago',
  'media-ui-core_approxYearsAgoLong': '{years} years ago',
  'media-ui-core_anHourAgo': 'An hour ago',
  'media-ui-core_updatedTime': 'Updated on {date} at {time}',
  'media-ui-core_policyAgreeShort':
    'By submitting my information, I agree to the <link>Privacy Policy</link> and <link>Terms of Service</link>.',
  'media-ui-core_policyAgreeOffers':
    'By continuing, I agree that Bloomberg may send me news and offers relating to Bloomberg products. I also acknowledge the <link>Privacy Policy</link> and agree to the <link>Terms of Service</link>.',
  'media-ui-core_policyAgreeUSFull':
    'By continuing, I agree to the <link>Privacy Policy</link> and <link>Terms of Service</link>.',
  'media-ui-core_navigationDot': 'navigation dot',
  'media-ui-core_navigateLeft': 'navigate left',
  'media-ui-core_navigateRight': 'navigate right',
  'media-ui-core_onlyEnterNumbers': 'You can only enter numbers',
  'media-ui-core_fillOutAllFields': 'Please fill out all fields',
  'media-ui-core_digitNOfTotal': 'Digit {position} of {total}',
  'media-ui-core_offersAndPromotions':
    'Bloomberg may send me offers and promotions.',
};

export default defaultMessages;
